import ContentLoader from 'react-content-loader';
import type { VoidFunctionComponent } from 'react';

const DrawerLoadingHeader: VoidFunctionComponent = () => (
  <ContentLoader width="100%" height="60px">
    <rect x="0" y="0" rx="3" ry="3" width="90%" height="30" />
    <rect x="0" y="40" rx="3" ry="3" width="90px" height="18" />
    <rect x="100px" y="40" rx="3" ry="3" width="25%" height="18" />
  </ContentLoader>
);

const DrawerLoadingDescription: VoidFunctionComponent = () => (
  <ContentLoader width="100%" height="120px">
    <rect x="0" y="2" rx="3" ry="3" width="85px" height="18" />
    <rect x="0" y="34" rx="3" ry="3" width="100%" height="14" />
    <rect x="0" y="54" rx="3" ry="3" width="100%" height="14" />
    <rect x="0" y="74" rx="3" ry="3" width="100%" height="14" />
    <rect x="0" y="94" rx="3" ry="3" width="100%" height="14" />
  </ContentLoader>
);

const DrawerLoadingDetails: VoidFunctionComponent = () => (
  <ContentLoader width="100%" height="215px">
    <rect x="0" y="10" rx="3" ry="3" width="100%" height="25" />
    <rect x="0" y="45" rx="3" ry="3" width="100%" height="25" />
    <rect x="0" y="80" rx="3" ry="3" width="100%" height="25" />
    <rect x="0" y="115" rx="3" ry="3" width="100%" height="25" />
    <rect x="0" y="150" rx="3" ry="3" width="100%" height="25" />
    <rect x="0" y="185" rx="3" ry="3" width="100%" height="25" />
  </ContentLoader>
);

const DrawerLoadingNVDBaseMetrics: VoidFunctionComponent = () => (
  <ContentLoader width="100%" height="285px">
    <rect x="0" y="10" rx="3" ry="3" width="100%" height="25" />
    <rect x="0" y="45" rx="3" ry="3" width="100%" height="25" />
    <rect x="0" y="80" rx="3" ry="3" width="100%" height="25" />
    <rect x="0" y="115" rx="3" ry="3" width="100%" height="25" />
    <rect x="0" y="150" rx="3" ry="3" width="100%" height="25" />
    <rect x="0" y="185" rx="3" ry="3" width="100%" height="25" />
    <rect x="0" y="220" rx="3" ry="3" width="100%" height="25" />
    <rect x="0" y="255" rx="3" ry="3" width="100%" height="25" />
  </ContentLoader>
);

export default {
  Header: DrawerLoadingHeader,
  Description: DrawerLoadingDescription,
  Details: DrawerLoadingDetails,
  NVDBaseMetrics: DrawerLoadingNVDBaseMetrics,
};
